// extracted by mini-css-extract-plugin
export default {"containerBody":"Log_containerBody__B503M","token":"Log_token__MfGjP","vpnImg":"Log_vpnImg__0CJHm"};